const sales = require('./sales');
const common = require('./common');
const client = require('./client');
const banking = require('./banking');

/**
 * Schemas are jsonschema compliant files to use in validators
 * @namespace schemas
 * @property {module:schemas/sales} sale - schema compliant file for sales
 * @property {module:schemas/common} common - schema compliant file for common validation
 * @property {module:schemas/client} client - schema compliant file for client-api
 * @property {module:schemas/banking} banking - schema compliant file for banking-api
 *
 */
module.exports = {
  sales,
  common,
  client,
  banking,
};
